export const BasePath = 'https://triverseadvertising.com/homeandsoul_website/admin-portal/api';